import React from 'react'
import { useTranslation } from '../../hooks/useTranslation'

const socialLinks = [
  {
    name: 'WhatsApp',
    url: 'https://wa.me/966502035455?text=السلام عليكم، أود الاستفسار عن خدماتكم',
    icon: '/images/icons/whatsapp.svg',
    hoverColor: '#25d366',
  },
  {
    name: 'YouTube',
    url: 'https://www.youtube.com/@badanibex',
    icon: '/images/icons/youtube.svg',
    hoverColor: '#ff0000',
  },
  {
    name: 'Blogger',
    url: 'https://lorienx.blogspot.com/',
    icon: '/images/icons/blogger.svg',
    hoverColor: '#d4af37',
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/badanibex',
    icon: '/images/icons/instagram.svg',
    hoverColor: '#e1306c',
  },
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/share/18aePf5nt9/?mibextid=wwXIfr',
    icon: '/images/icons/facebook.svg',
    hoverColor: '#1877f2',
  },
  {
    name: 'X (Twitter)',
    url: 'https://x.com/badanibex',
    icon: '/images/icons/twitter.svg',
    hoverColor: '#1da1f2',
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/in/badanibex-by-fahd-ali-digital-products-saas-solutions-aa8134330/',
    icon: '/images/icons/linkedin.svg',
    hoverColor: '#0077b5',
  },
  {
    name: 'GitHub',
    url: 'https://github.com/badanibex',
    icon: '/images/icons/github.svg',
    hoverColor: '#ffffff',
  },
  {
    name: 'Product Hunt',
    url: 'https://www.producthunt.com/@badanibex',
    icon: '/images/icons/product.png',
    hoverColor: '#ffffff',
  },
]

const SocialIcons: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div>
      <p className="text-xs mb-3" style={{ color: 'var(--text-muted)' }}>
        {t('footer.social.follow')}
      </p>
      <div className="flex items-center gap-2.5 flex-wrap">
        {socialLinks.map(social => (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-10 h-10 rounded-xl transition-all duration-200 group"
            style={{
              backgroundColor: 'var(--surface-2)',
              border: '1px solid var(--border)',
            }}
            onMouseEnter={e => {
              const el = e.currentTarget as HTMLElement
              el.style.borderColor = `${social.hoverColor}55`
              el.style.boxShadow = `0 0 14px ${social.hoverColor}33`
              el.style.transform = 'translateY(-3px)'
            }}
            onMouseLeave={e => {
              const el = e.currentTarget as HTMLElement
              el.style.borderColor = 'var(--border)'
              el.style.boxShadow = 'none'
              el.style.transform = 'translateY(0)'
            }}
            title={social.name}
            aria-label={social.name}
          >
            <img
              src={social.icon}
              alt={social.name}
              className="w-5 h-5 object-contain opacity-70 group-hover:opacity-100 transition-opacity duration-200 dark:invert dark:opacity-60 dark:group-hover:opacity-90"
            />
          </a>
        ))}
      </div>
    </div>
  )
}

export default SocialIcons